module.exports = __webpack_public_path__ + "static/media/wv-hope-joy-justice-logo-2022.21c6ff07.png";